/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import { getContentFromContentStack } from "../../core/contentStack";
import i18n from "../../i18n";
import BottomSection from "../shared-ui/bottom-section";
import EmailSendPopup from "../shared-ui/popup/email-send";
import HeaderOptionsPopup from "../shared-ui/popup/header-options";
import { SENDTNCEMAIL, ADDUSERTNCCONSENTAGREEMENT } from "../../queries/terms";
import { setUserLanguage } from "../../services/suggesticServices";
import { withOktaAuth } from "@okta/okta-react";
import { handleUpdateUserAPI } from "../../services/recommendationService";

// Infterface for TermsConditions State
interface TermsConditionsState {
  isPopupOpen: boolean;
  iAgree: boolean;
  loading: boolean;
  result: any;
  error: object;
  isLangPopupOpen: boolean;
  contentTypeId: string;
  isTooltipOpen: boolean;
  closeTerms: boolean;
}

/**
 * Terms and Condition component.
 *
 * @namespace TermsConditions
 */
class TermsConditions extends React.Component<any, TermsConditionsState> {
  node: any;
  constructor(props: any) {
    super(props);
    this.state = {
      isPopupOpen: false,
      isLangPopupOpen: false,
      contentTypeId: "ms_terms_and_conditions",
      iAgree: true,
      loading: true,
      result: [],
      error: {},
      isTooltipOpen: false,
      closeTerms: false,
    };
  }

  componentDidMount() {
    // Create a media condition that targets viewports at least 768px wide
    // const mediaQuery = window.matchMedia("(max-width: 992px)");
    // Check if the media query is true
    // if (this.props.show) {
    // Then trigger an alert
    this.setState({
      iAgree: false,
    });
    // }

    //getContentFormComponenet function is called here
    this.getContentForComponent(this.state.contentTypeId);

    //Language popup close on outside click functionality is added here
    const concernedElement: Element | any =
      document.querySelector(".header-icons");
    document.addEventListener("mousedown", (event) => {
      if (!concernedElement.contains(event.target)) {
        this.setState({
          isLangPopupOpen: false,
        });
      }
    });
  }

  componentWillReceiveProps(props: any) {
    //getContentFormComponenet function is called here
    if (props && props.i18n.language) {
      this.getContentForComponent(this.state.contentTypeId);
    }
  }

  componentDidUpdate = () => {
    if (this.props.show) {
      // attach/remove event handler
      document.addEventListener("click", this.handleOutsideClick, true);
      document.addEventListener(
        "keydown",
        (e: any) => {
          if (e.key === "Escape") {
            this.handleOutsideClick(e);
          }
        },
        true
      );
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
      document.removeEventListener(
        "keydown",
        (e: any) => {
          if (e.key === "Escape") {
            this.handleOutsideClick(e);
          }
        },
        false
      );
    }
  };

  handleOutsideClick = (e: any) => {
    // ignore clicks on the component itself
    if (this.node) {
      if (this.node.contains(e.target)) {
        return;
      }
      this.handleClose();
    }
  };

  /**
   * This method is used for handle send Email popup open
   *
   */
  handleSendEmailPopup = () => {
    this.setState({
      isPopupOpen: true,
    });
  };

  /**
   * This method is used for handle send Email popup close
   *
   */
  closePopup = () => {
    this.setState({
      isPopupOpen: false,
    });
  };

  /**
   * This method is used for handle page bottom scroll
   * @param {any} event
   *
   */
  handleScroll = (event: any) => {
    const target = event.target;
    if (
      Math.ceil(target.scrollHeight - target.scrollTop) === target.clientHeight
    ) {
      if (!this.state.iAgree) {
        this.setState({
          iAgree: true,
        });
      }
    }
  };
  
  /**
   * This method is used for handle Agree button
   *
   */
  handleOnAgree =async () => {
    localStorage.setObj("user-consent", "accepted");
    let userConsentObj: any = {}
    if(localStorage.getObj("user-info")) {
      let userInfoData = localStorage.getObj("user-info");
        userConsentObj.partyId  = userInfoData?.partyId
        userConsentObj.userConsent = true
      await handleUpdateUserAPI(userConsentObj).then((resp: any) => {
        this.props.history.push("/foundational");
      })
      .catch((err: any) => {
        console.log("error-->",err)
      })
    }
    else{
      this.props.history.push("/foundational");
    }
      // .then((res: any) => {
      //   const statusCode =
      //     res.data &&
      //     res.data.addUserTncConsentAgreement &&
      //     res.data.addUserTncConsentAgreement.code;
      //   // if(statusCode === 200 && sessionStorage.getItem("before-login-consent")){

      //   // }
      //   if (statusCode === 200) {
      //     if (sessionStorage.getItem("before-login-consent")) {
      //       localStorage.setObj("isAuthCalled",false);
      //       localStorage.setItem("previousPath", this.props.history?.location?.pathname)
      //       this.props?.oktaAuth?.signInWithRedirect().then(() => {
      //         sessionStorage.removeItem("before-login-consent");
      //       });
      //       sessionStorage.removeItem("before-login-consent");
      //     } else {
      //       this.props.history.push("/foundational");
      //     }
      //   } else {
      //     if (sessionStorage.getItem("before-login-consent")) {
      //       localStorage.setObj("isAuthCalled",false);
      //       localStorage.setItem("previousPath", this.props.history?.location?.pathname)
      //       this.props?.oktaAuth?.signInWithRedirect().then(() => {
      //         sessionStorage.removeItem("before-login-consent");
      //       });
      //       sessionStorage.removeItem("before-login-consent");
      //     } else {
      //       this.props.history.push("/foundational");
      //     }
      //     console.log("Error");
      //   }
      // })
      // .catch((err: any) => {
      //   if (sessionStorage.getItem("before-login-consent")) {
      //     localStorage.setObj("isAuthCalled",false);
      //     localStorage.setItem("previousPath", this.props.history?.location?.pathname)
      //     this.props?.oktaAuth?.signInWithRedirect().then(() => {
      //       sessionStorage.removeItem("before-login-consent");
      //     });
      //     sessionStorage.removeItem("before-login-consent");
      //   } else {
      //     this.props.history.push("/foundational");
      //   }
      //   // this.props.history.push("/foundational");
      //   console.log(err);
      // });
  };

  /**
   * This method is used for handle language popup
   *
   */
  handleLangPopup = () => {
    this.setState({
      isLangPopupOpen: !this.state.isLangPopupOpen,
    });
  };

  /**
   * This method is used to handle content from content stack
   * @param {string} contentTypeId
   *
   */

  getContentForComponent = (contentTypeId: string) => {
    getContentFromContentStack(contentTypeId)
      .then((response) => {
        if (response && response.error_message) {
          this.setState({
            error: response,
          });
        } else {
          this.setState({
            result: response && response[0],
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * This method is used to update the languge type
   *
   *
   */

  updateContentLanguageOnClick = () => {
    //languageType is fetched from session storage here
    const language = sessionStorage.getItem("languageTypeOfApp") || "en-us";
    const languageType =
      language === null ? "es-us" : language === "en-us" ? "es-us" : "en-us";
    i18n.changeLanguage(languageType);

    //languageType is set on session storage here
    sessionStorage.setItem("languageTypeOfApp", languageType || "es-us");

    //suggestic call for updating user language
    if (localStorage.getItem("uniqueId")) {
      setUserLanguage();
    }
    this.getContentForComponent(this.state.contentTypeId);
    this.setState({
      isLangPopupOpen: false,
    });
  };
  updateContentLanguageOnKeyPress = (event: any) => {
    if (event.key === "Enter") {
      this.updateContentLanguageOnClick();
    }
  };
  /**
   * This method is used to handle T & C email copy API
   *@param {string} emailId
   *
   */
  handleTCEmail(emailId: string) {
    this.props.client
      .query({
        query: SENDTNCEMAIL,
        variables: {
          email: emailId,
        },
        fetchPolicy: "no-cache",
      })
      .then((res: any) => {
        const statusCode =
          res.data && res.data.sendEmail && res.data.sendEmail.status;

        if (statusCode === 200) {
          this.setState(
            {
              isTooltipOpen: true,
            },
            () =>
              setTimeout(() => this.setState({ isTooltipOpen: false }), 3000)
          );
        } else {
          console.log("Error");
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
    this.closePopup();
  }

  /**
   * This method is used to handle terms popup close button
   *
   */
  handleClose = (e?: any) => {
    this.setState(
      {
        closeTerms: true,
      },
      () => {
        this.props.handleClose();
      }
    );
  };
  render() {
    const { isPopupOpen, result, isTooltipOpen } = this.state;
    const { title, screen_header, summary_list, single_line } =
      (result && result[0]) || {};
    const languageType = sessionStorage.getItem("languageTypeOfApp") || "en-us";
    let animationClass = "terms-condition-wrapper hide";
    if (this.state.closeTerms) {
      animationClass =
        "terms-condition-wrapper animated slideInRight close-terms";
    }
    if (this.props.show) {
      animationClass = "terms-condition-wrapper animated slideInLeft";
    }
    return (
      <>
        <div className={this.props.show ? "overlay" : "overlay hide"}></div>
        <div
          className={animationClass}
          ref={(node) => {
            this.node = node;
          }}
        >
          {/* <EmailSendPopup
            {...this.props}
            open={isPopupOpen}
            close={this.closePopup}
            handleSend={(emailId: string) => this.handleTCEmail(emailId)}
          /> */}
          <div className="terms-condition-header-container">
            {/* title is fetched here */}
            <div className="header-title">{title}</div>
            <div className="header-icons">
              <div className="icon-wrapper">
                <span
                  role="button"
                  tabIndex={0}
                  aria-label="language translator"
                  className={
                    this.state.isLangPopupOpen
                      ? "icon lang-icon active"
                      : "icon lang-icon"
                  }
                  onClick={this.handleLangPopup}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      this.handleLangPopup();
                    }
                  }}
                ></span>
                <HeaderOptionsPopup
                  list={[
                    languageType === "en-us"
                      ? this.props.t("common.spanish_label")
                      : this.props.t("common.english_label"),
                  ]}
                  open={this.state.isLangPopupOpen}
                  handleOptionClick={this.updateContentLanguageOnClick}
                  handleOptionKeyPress={(e: any) =>
                    this.updateContentLanguageOnKeyPress(e)
                  }
                />
              </div>
              {/* <span className="icon lang-icon"></span> */}
              <span
                tabIndex={0}
                role="button"
                aria-label="close tab"
                className="icon cross-icon"
                onClick={this.handleClose}
                onKeyPress={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.handleClose(e);
                  }
                }}
              ></span>
            </div>
          </div>
          <div
            tabIndex={-1}
            className={"terms-wrapper blur-effect"}
            onScroll={this.handleScroll}
            onKeyDown={this.handleScroll}
          >
            {/* Email Sent Tooltip Start */}
            <div
              className={
                this.state.isTooltipOpen ? "tooltip-container" : "hide"
              }
            >
              <div className="tooltip-label">
                {this.props.t("common.email_sent_label")}
              </div>
            </div>
            {/* Email Sent Tooltip Ends */}

            <div className="bootstrap-wrapper">
              <div className="row">
                <div className="inner-wrapper col-md-12 clearfix">
                  {/* Left section Start */}
                  <div className="left-wrapper">
                    {/* <div className="icon leaves-icon"></div> */}
                    <div className="main-title">{screen_header}</div>
                    {/* summary_list is fetched here */}
                    <div className="list-container">
                      <ul>
                        {summary_list &&
                          summary_list.length > 0 &&
                          summary_list.map((text: string, indexId: any) => {
                            return <li className="terms" key={indexId}>{text}</li>;
                          })}
                      </ul>
                    </div>
                  </div>
                  {/* Left section Ends */}
                  {/* Right section Start */}
                  {/* <div className="right-wrapper">
                    <div className="list-container">
                      <ul>
                        {single_line &&
                          single_line.map((text: string) => {
                            return <ul className="terms">{text}</ul>;
                          })}
                      </ul>
                    </div>
                  </div> */}
                  {/* Right section Ends */}
                </div>
              </div>
            </div>
          </div>
          <BottomSection
            {...this.props}
            id={"iAgree"}
            emailText={true}
            handleSendEmail={this.handleSendEmailPopup}
            iAgree={this.state.iAgree}
            btnName={this.props.t("common.bottom_section_i_agree")}
            handleButtonClick={this.handleOnAgree}
            btnClassName={
              "app-btn btn-icon"
              // this.state.iAgree
              //   ? "app-btn btn-icon"
              //   : "app-btn btn-icon disagree"
            }
          />
        </div>
      </>
    );
  }
}

export default withOktaAuth(TermsConditions);
